export const CVG_UID_COOKIE = '__cvg_uid';
export const CVG_UID_ATTRIBUTE_KEY = 'cvg_uid';
